import React from 'react';
import PrimaryNavbar from './PrimaryNavbar';
import SecondaryNavbar from './SecondaryNavbar';
import PublicFooter from './PublicFooter';
import ArcaAgentWidget from './ArcaAgentWidget';

const PublicLayout = ({ children, user, onLogout, isHomePage = false }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <SecondaryNavbar />
      <PrimaryNavbar user={user} onLogout={onLogout} />
      <main className="flex-grow">
        {children}
      </main>
      <PublicFooter />
      <ArcaAgentWidget autoOpen={isHomePage} />
    </div>
  );
};

export default PublicLayout;